module.exports = {
	SUPPORTED_LANGUAGES: ['en', 'ar', 'es-ES', 'fr', 'it', 'lt', 'ru', 'et'], // todo add 'uk-UA' when translated
	BNK_TOKEN_DISABLED_COUNTRIES: ['LT', 'JP', 'US'],
	SCA_IDLE_TIMER: 4 * 60 * 1000,
	NON_SCA_IDLE_TIMER: 29 * 60 * 1000,
};
